<template>
  <a-modal
    centered
    :visible="visible"
    :title="mode === 'create' ? '新建供应商' : '修改供应商'"
    @ok="on_submit"
    @cancel="cancel"
    :confirmLoading="submitting"
    :width="720"
  >
    <a-form-model :model="form" ref="supplier_create" :rules="rules">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="联系人姓名" prop="contact_name">
            <a-input v-model="form.contact_name" />
          </a-form-model-item>

          <a-form-model-item label="联系电话" prop="contact_tel" extra="如果该供应商注册过平台账户，系统会自动将供应商与该客户进行关联">
            <a-input v-model="form.contact_tel" />
          </a-form-model-item>
          <a-form-model-item label="联系QQ">
            <a-input v-model="form.contact_qq" />
          </a-form-model-item>
          <a-form-model-item label="联系地址">
            <a-input v-model="form.contact_address" />
          </a-form-model-item>
          <a-form-model-item label="公司名称" prop="company">
            <a-input v-model="form.company" />
          </a-form-model-item>
          <a-row :gutter="12">
            <a-col :span="8">
              <a-form-model-item label="是否包公正">
                <a-switch v-model="form.is_include_notary" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="是否包转让费">
                <a-switch v-model="form.is_include_transfer" />
              </a-form-model-item
              >
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="是否包开票">
                <a-switch v-model="form.is_include_invoice" />
              </a-form-model-item
              >
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="收款方式">
            <a-radio-group v-model="form.payment_type" button-style="solid">
              <a-radio-button value="alipay">
                支付宝
              </a-radio-button>
              <a-radio-button value="bank">
                银行
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <template v-if="form.payment_type === 'bank'">
            <a-form-model-item label="银行开户行">
              <a-input v-model="form.payment_name" />
            </a-form-model-item>
            <a-form-model-item label="银行开户名">
              <a-input v-model="form.payment_account" />
            </a-form-model-item>
            <a-form-model-item label="银行账号">
              <a-input v-model="form.payment_no" />
            </a-form-model-item>
          </template>

          <template v-if="form.payment_type === 'alipay'">
            <a-form-model-item label="支付宝户名">
              <a-input v-model="form.payment_account" />
            </a-form-model-item>
            <a-form-model-item label="支付宝账号">
              <a-input v-model="form.payment_no" />
            </a-form-model-item>
          </template>

          <a-form-model-item label="备注">
            <a-textarea v-model="form.remark" />
          </a-form-model-item>

          <a-form-model-item label="下架">
            <a-button-group>
              <a-button :type="form.stopSell==0?'primary':'dashed'" @click="form.stopSell=0">正常</a-button>
              <a-button :type="form.stopSell==1?'danger':'dashed'" @click="form.stopSell=1">下架</a-button>
            </a-button-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
let init_form = {
  company: null,
  contact_address: null,
  contact_qq: null,
  contact_tel: null,
  contact_name: null,
  member_id: null,
  is_include_invoice: false,
  is_include_transfer: false,
  is_include_notary: false,
  payment_type: "alipay",
  payment_name: null,
  payment_account: null,
  payment_no: null,
  remark: null,
  stopSell: 0
};
export default {
  props: {
    visible: {
      default: false
    },
    record: null,
    callback: null,
    mode: {
      default: "create"
    }
  },
  data() {
    return {
      submitting: false,
      form: {},
      rules: {
        contact_name: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入链接"
          }
        ],
        contact_tel: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入联系电话"
          }
        ]
      }
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
  },
  watch: {
    visible(v) {
      if (v && this.record) {
        Object.keys(this.form).map((v) => {
          if (Object.prototype.hasOwnProperty.call(this.record, v)) {
            switch (v) {
              case "is_include_invoice":
              case "is_include_transfer":
              case "is_include_notary":
                this.form[v] = !!this.record[v];
                break;
              default:
                this.form[v] = this.record[v];
            }
          }
        });
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    on_submit() {
      this.$refs["supplier_create"].validate((valid) => {
        if (valid) {
          if (this.mode === "create") {
            return this.on_create();
          } else {
            return this.on_edit();
          }
        } else {
          this.$message.error("请检查并填写完需要录入的内容");
          return false;
        }
      });
    },
    on_create() {
      this.submitting = true;
      this.$http
        .post("/trademark/supplier", this.form)
        .then((res) => {
          if (res.success) {
            this.cancel();
            if (this.callback) {
              this.callback();
            }
          }
        })
        .catch()
        .then(() => {
          this.submitting = false;
        });
    },
    on_edit() {
      this.submitting = true;
      this.$http
        .put("/trademark/supplier/" + this.record.id, this.form)
        .then((res) => {
          if (res.success) {
            this.cancel();
            if (this.callback) {
              this.callback();
            }
          }
        })
        .catch()
        .then(() => {
          this.submitting = false;
        });
    },
    after_close() {
      this.$refs["supplier_create"].resetFields();

      this.form = JSON.parse(JSON.stringify(init_form));
    }
  }
};
</script>
